import React, { useState } from 'react';
import background from "../Assets/backGround.jpg";
import { Button } from "react-bootstrap";
import FormSelection from "../components/modals/FormSelection";

const MainPage = () => {

    // State для управления видимостью модального окна бронирования
    const [formSelectionVisible, setFormSelectionVisible] = useState(false);

    return (
        <>
            <div
                className="main-page-hero-section"
                style={{
                    backgroundImage: `url(${background})` // <-- Задаем backgroundImage инлайн из импортированной переменной
                    // Остальные стили фона (size, position, repeat, height) должны быть в CSS
                }}
            >
                <div className="hero-content-container">

                    {/* Блок приветствия и кнопки бронирования */}
                    <div className="welcome-block">
                        {/* Главный заголовок страницы */}
                        <h1 className="welcome-title">
                            Добро пожаловать в Санаторий "Центросоюз"<f>*</f> {/* Тег <f> для стилизации звездочки */}
                        </h1>
                        {/* Кнопка для вызова модального окна бронирования */}
                        <Button
                            variant="success" // Используем стандартный зеленый стиль Bootstrap кнопки
                            className="booking-button" // Наш кастомный класс для стилизации
                            onClick={() => setFormSelectionVisible(true)} // Обработчик клика
                        >
                            Забронировать
                        </Button>
                    </div>

                    {/* Блок контактной информации (Телефон и WhatsApp) */}
                    <div className="contact-info-block">
                        {/* Текст "Телефон - Бесплатная линия:" */}
                        <p className="contact-text">
                            Телефон - Бесплатная линия:
                        </p>
                        {/* Номер телефона */}
                        <h2 className="phone-number">
                            8-800-505-56-77
                        </h2>
                        {/* Текст "WhatsApp:" */}
                        <p className="contact-text">
                            WhatsApp - пишите:
                        </p>

                        <h2 className="whatsapp-number">
                            8-928-310-25-33
                        </h2>

                        <p className="contact-text">
                            MAX - пишите:
                        </p>

                        <h2 className="whatsapp-number">
                            8-928-310-25-33
                        </h2>
                    </div>

                </div>
                {/* Конец .hero-content-container */}

                {/* ДОБАВЛЕНО: Элемент для сноски в правом нижнем углу */}
                <p className="footnote">
                    *Сайт-партнер Санатория Центросоюз
                </p> {/* <-- ДОБАВЛЕНО */}

            </div> {/* Конец .main-page-hero-section */}

            {/* Модальное окно бронирования */}
            <FormSelection show={formSelectionVisible} onHide={() => setFormSelectionVisible(false)}/>
        </>
    );
};

export default MainPage;